import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politica-de-datos',
  templateUrl: './politica-de-datos.component.html',
  styleUrls: ['./politica-de-datos.component.scss']
})
export class PoliticaDeDatosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
